const getGuests = (addon, usesAttributes = false) => {
  const guests = addon.serviceDetails?.guestCounts?.guestCount;
  if (!guests) return [];

  return guests
    .map((p) => ({
      minAge: usesAttributes ? parseInt(p.attributes.ageQualifyingCode, 10) : parseInt(p.ageQualifyingCode, 10),
      count: usesAttributes ? parseInt(p.attributes.count, 10) : parseInt(p.count, 10),
    }))
    .sort((a, b) => b.minAge - a.minAge);
};

const getBasePrice = (addon, usesAttributes = false) => {
  const basePrice = addon.price[0].base;
  if (!basePrice) return null;
  return usesAttributes ? parseFloat(basePrice.attributes.amountAfterTax) : parseFloat(basePrice.amountAfterTax);
};

const getPriceClasses = (addon, usesAttributes = false) => {
  const priceClasses = addon.price[0].additionalGuestAmounts?.additionalGuestAmount;
  if (!priceClasses) return null;

  return priceClasses
    .map((p) => ({
      minAge: usesAttributes ? parseInt(p.attributes.ageQualifyingCode, 10) : parseInt(p.ageQualifyingCode, 10),
      price: usesAttributes ? parseFloat(p.amount.attributes.amountAfterTax) : parseFloat(p.amount.amountAfterTax),
    }))
    .sort((a, b) => b.minAge - a.minAge);
};

const addonCommentAsText = (addon, name, usesAttributes = false) => {
  const comment = addon.serviceDetails.comments.comment.find((c) => (usesAttributes ? c.attributes.name === name : c.name === name));
  if (comment) {
    return comment.text;
  }
};

export const getAddOn = (service, duration, usesAttributes = false) => {
  const code = usesAttributes ? service.attributes.serviceInventoryCode : service.serviceInventoryCode;
  const basePrice = getBasePrice(service, usesAttributes);
  const guests = getGuests(service, usesAttributes);
  const priceClasses = getPriceClasses(service, usesAttributes);
  const title = addonCommentAsText(service, 'Title', usesAttributes) || addonCommentAsText(service, 'Category', usesAttributes);

  let total = 0;
  if (priceClasses) {
    priceClasses.forEach((p, idx) => {
      total += p.price * duration * guests[idx].count;
    });
  } else {
    total = guests[0].count * basePrice * duration;
  }

  return {
    basePrice,
    code,
    guests,
    priceClasses,
    title,
    total,
  };
};
